(function () {
  'use strict';

  var isReploPage =
    document.getElementById('replo-fullpage-element') ||
    document.querySelector('[data-replo-add-product-variant-to-cart]');

  if (!isReploPage) return;

  var refreshTimer = null;
  var lastBogosTrigger = 0;
  var BOGOS_DEBOUNCE_MS = 1500;

  function refreshThemeCart(openPopup) {
    if (!window.Store) return Promise.resolve();

    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cartData) {
        window.Store.dispatch({
          type: 'cart/getCart/fulfilled',
          payload: cartData,
        });

        if (openPopup !== false) {
          window.Store.dispatch({ type: 'cart/openPopup' });
        }

        return cartData;
      })
      .catch(function (error) {
        console.error('Replo cart bridge: failed to sync cart', error);
      });
  }

  function scheduleCartSync(openPopup) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshThemeCart(openPopup);
    }, 400);
  }

  function triggerBogosGiftLogic(cartData) {
    var now = Date.now();
    if (now - lastBogosTrigger < BOGOS_DEBOUNCE_MS) return;
    lastBogosTrigger = now;

    try {
      document.dispatchEvent(
        new CustomEvent('bogos:gifts', { detail: cartData })
      );
    } catch (error) {
      /* noop */
    }

    if (
      typeof window.BOGOS_CORE !== 'undefined' &&
      window.BOGOS_CORE.helper &&
      typeof window.BOGOS_CORE.helper.updateCore === 'function'
    ) {
      try {
        window.BOGOS_CORE.helper.updateCore({ cart: cartData });
      } catch (error) {
        /* noop */
      }
    }
  }

  function afterCartMutation() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cartData) {
        triggerBogosGiftLogic(cartData);
        scheduleCartSync(true);

        // BOGOS adds gifts asynchronously — refresh again after it finishes.
        setTimeout(function () {
          scheduleCartSync(true);
        }, 1200);
        setTimeout(function () {
          scheduleCartSync(false);
        }, 2500);
      })
      .catch(function () {
        scheduleCartSync(true);
      });
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url));
  }

  document.addEventListener('fg-gifts:updated', function () {
    scheduleCartSync(true);
  });

  var nativeFetch = window.fetch;

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url =
        typeof input === 'string'
          ? input
          : input && typeof input.url === 'string'
            ? input.url
            : '';

      var promise = nativeFetch.apply(this, arguments);

      if (!isCartAddUrl(url)) {
        return promise;
      }

      return promise.then(function (response) {
        if (response.ok) {
          afterCartMutation();
        }

        return response;
      });
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._reploCartBridgeUrl = url;
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    var url = xhr._reploCartBridgeUrl || '';

    if (isCartAddUrl(url)) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          afterCartMutation();
        }
      });
    }

    return nativeSend.apply(this, arguments);
  };
})();
